import React from 'react';
import { Box, Color, Display, FlexDirection, withCitrusTheme } from '@gousto-internal/citrus-react';

type RecipeCardFooterProps = {
  children: React.ReactNode;
};

const FooterContainer = withCitrusTheme(Box, (theme) => [
  theme.responsiveSpacing([4], ['paddingBottom']),
  theme.responsiveSpacing([4, null, 6], ['paddingTop']),
]);

export function Footer(props: RecipeCardFooterProps) {
  return (
    <FooterContainer
      bg={Color.White}
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      gridArea="footer"
      paddingH={[3, null, 4]}
      height="100%"
    >
      {props.children}
    </FooterContainer>
  );
}
